module.exports = __webpack_public_path__ + "static/media/posto-symbol.07a1375e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posto-symbol.svg
// module id = 1310
// module chunks = 1